import { request } from '@/request/index';

// 测试登录
export function testUserTestLogin(userId, appid) {
    return request({
        method: "POST",
        data: {
            action: "userLogin",
            userId,
            appid
        }
    })
}

// 用户登录
export function userLogin(id, region, appid) {
    return request({
        baseURL: "https://webpay.ivymobile.com/",
        method: "POST",
        url: "",
        data: {
            // appid: appid,
            action: "fortress_user_login",
            code: id,
            server_id: region
        }
    })
}